import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { forwardRef as R, useRef as N, useState as d, useEffect as k } from "react";
import { tv as A } from "../tailwind-variants.config.js";
import { DragIcon as E } from "./assets/DragIcon.js";
import { mergeRefs as L } from "./tools.js";
import { ErrorMessage as C } from "../ErrorMessage/index.js";
const B = "_root_7xp3p_1", S = {
  root: B
}, T = A({
  slots: {
    textArea: "jm-box-border jm-block jm-w-full jm-border jm-border-solid jm-border-jutro-new-warm-gray-500 jm-text-jutro-new-warm-gray-800 lg:jm-max-h-none focus:jm-border-jutro-new-blue-800 focus:jm-outline-none focus:jm-ring-0 jm-font-paragraph-1 jm-overflow-y-auto placeholder:jm-text-jutro-new-warm-gray-500 jm-px-4 jm-pt-[9px] jm-pb-[7px] jm-rounded-lg disabled:jm-bg-jutro-new-warm-gray-100 disabled:jm-border-jutro-new-warm-gray-300",
    counter: "jm-absolute jm-bottom-1 jm-right-4 jm-text-jutro-new-warm-gray-800 jm-select-none jm-pointer-events-none jm-cursor-default jm-font-caption",
    resizer: "jm-absolute jm-bottom-[3px] jm-right-[3px] jm-w-4 jm-h-4 jm-pointer-events-none"
  },
  variants: {
    maxLength: {
      true: {
        textArea: "jm-min-h-[58px] jm-max-h-[178px] jm-pb-6"
      },
      false: {
        textArea: "jm-min-h-11 jm-max-h-[166px]",
        counter: "jm-hidden"
      }
    },
    isResizable: {
      true: {
        textArea: "jm-resize-none md:jm-resize-y",
        resizer: "jm-hidden md:jm-block"
      },
      false: { textArea: "jm-resize-none", resizer: "jm-hidden" }
    },
    error: {
      true: {
        textArea: "jm-border-2 jm-border-jutro-new-rose-600 focus:jm-border-jutro-new-rose-600"
      }
    },
    disabled: {
      true: {
        counter: "jm-text-jutro-new-warm-gray-500"
      }
    }
  },
  defaultVariants: {
    maxLength: !1,
    isResizable: !0,
    error: !1,
    disabled: !1
  }
}), V = R(
  (h, f) => {
    const {
      label: s,
      name: l,
      placeholder: g,
      onChange: a,
      disabled: i,
      maxLength: n,
      error: j,
      value: t,
      isResizable: x,
      sideLabelElement: c,
      ...b
    } = h, e = N(null), [p, u] = d(!1), [w, y] = d(0), { textArea: z, counter: v, resizer: H } = T({
      maxLength: !!n,
      error: !!j,
      isResizable: x,
      disabled: i
    });
    return k(() => {
      if (e.current) {
        if (e.current.scrollHeight > 176 && (e.current.scrollTop = e.current.scrollHeight), p) {
          const o = Number(
            e.current.style.height.slice(0, -2)
          );
          e.current.scrollHeight >= o && u(!1);
          return;
        }
        e.current.style.height = "inherit", e.current.style.height = `${e.current.scrollHeight}px`, y(e.current.scrollHeight);
      }
    }, [t]), /* @__PURE__ */ m(
      "div",
      {
        className: `jm-flex jm-w-full jm-flex-col jm-gap-1 ${S.root}`,
        children: [
          (s || c) && /* @__PURE__ */ m("div", { className: "jm-flex", children: [
            /* @__PURE__ */ r(
              "label",
              {
                htmlFor: l,
                className: "jm-font-label jm-block jm-w-full jm-text-jutro-new-warm-gray-800",
                children: s
              }
            ),
            /* @__PURE__ */ r("div", { className: "jm-hidden md:jm-block", children: c })
          ] }),
          /* @__PURE__ */ m(
            "div",
            {
              className: "jm-relative jm-w-full",
              onClick: (o) => {
                o.currentTarget.offsetHeight > w && u(!0);
              },
              children: [
                /* @__PURE__ */ r(
                  "textarea",
                  {
                    ...b,
                    ref: L(f, e),
                    id: l,
                    name: l,
                    placeholder: g,
                    value: t,
                    onChange: (o) => {
                      a && a(o);
                    },
                    disabled: i,
                    className: z(),
                    maxLength: n
                  }
                ),
                /* @__PURE__ */ m("div", { className: v(), children: [
                  (t == null ? void 0 : t.length) ?? 0,
                  "/",
                  n
                ] }),
                /* @__PURE__ */ r("div", { className: H(), onClick: () => console.log("RESIZED"), children: /* @__PURE__ */ r(E, {}) })
              ]
            }
          ),
          /* @__PURE__ */ r(C, { error: j })
        ]
      }
    );
  }
);
export {
  V as TextArea
};
//# sourceMappingURL=index.js.map
